export default __webpack_public_path__ + "static/media/ecommerce-header.bb56b4f1.jpg";